import React, { Fragment } from 'react';

import ChatMessageContent from './ChatMessageContent';
import {
  ChatBubble,
  ChatBubbleMeta,
  ChatBubbleRow,
  ChatDaySeparator,
} from './chatsWhatsapp.styles';
import { daySeparatorLabel, formatMessageDateTime, isSameChatDay } from './chatMessageDates';

const ChatMessagesList = ({ messages, token, conversationUuid, messageSenderLabel }) => (
  <>
    {messages.map((msg, index) => {
      const previous = index > 0 ? messages[index - 1] : null;
      const showDaySeparator =
        msg.created_at != null && !isSameChatDay(msg.created_at, previous?.created_at);
      const dateTimeLabel = formatMessageDateTime(msg.created_at);

      return (
        <Fragment key={msg.id}>
          {showDaySeparator ? (
            <ChatDaySeparator>{daySeparatorLabel(msg.created_at)}</ChatDaySeparator>
          ) : null}
          <ChatBubbleRow $side={msg.side}>
            <ChatBubble $side={msg.side}>
              <ChatMessageContent msg={msg} token={token} conversationUuid={conversationUuid} />
              <ChatBubbleMeta>
                {messageSenderLabel(msg)}
                {dateTimeLabel ? ` · ${dateTimeLabel}` : ''}
              </ChatBubbleMeta>
            </ChatBubble>
          </ChatBubbleRow>
        </Fragment>
      );
    })}
  </>
);

export default ChatMessagesList;
